import type { IconData } from '@stacksjs/iconify-core'

export const flashlight: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M39 12.818V7.064c0-1.83-1.251-3.373-3.07-3.565C33.603 3.253 29.797 3 24 3s-9.603.253-11.93.5C10.251 3.69 9 5.234 9 7.063v5.754c0 1.072.277 2.13.865 3.027c2.578 3.933 5.229 6.246 5.229 6.246c.332 7.439.9 15.357 1.202 19.341c.12 1.59 1.19 2.935 2.763 3.189c1.249.202 2.92.379 4.941.379s3.692-.177 4.94-.38c1.575-.253 2.643-1.598 2.764-3.188c.303-3.984.87-11.902 1.202-19.341c0 0 2.65-2.313 5.23-6.246c.586-.896.864-1.956.864-3.027\"/><path d=\"M39 10.578c-1.048-.207-5.268-.896-15-.896c-9.728 0-13.948.688-15 .896M24 28v4\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default flashlight
